import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useZakekeTryOn } from '../../../hooks/tryonContext';
import { TryOnBaseProviderReceivedMessage, TryOnBaseProviderResponseMessage, TryOnProviderExchangeData, TryOnProviderProps, ValueOf } from '../tryOnModels';

import { useInternalState } from '../../../state/provider';
import { TryOnFrame } from '../tryOnFrame';
import { IS_ANDROID, IS_IOS } from '../../../helpers';
// #region interfaces
const DeepARTryOnBaseReceivedMessage = {
	WaitingAuthentication: 'WAITING_AUTH',
	TryOnLoaded: 'MODEL_LOADED',
	ScreenShotTaken: 'SCREENSHOT_TAKEN',
	WebcamStopped: 'WEBCAM_STOPPED'
} as const;
export const DeepARTryOnReceivedMessage = { ...TryOnBaseProviderReceivedMessage, ...DeepARTryOnBaseReceivedMessage } as const;
export type DeepARTryOnReceivedMessageType = ValueOf<typeof DeepARTryOnReceivedMessage>;

const DeepARTryOnBaseResponseMessage = {
	StartAuthenticationTryOn: 'AUTH',
	LoadTryOn: 'LOAD_MODEL',
	LoadHands: 'LOAD_HANDS',
	TakeScreenshot: 'TAKE_SCREENSHOT',
	StopWebcam: 'STOP_WEBCAM'
} as const;

export const DeepARTryOnResponseMessage = { ...TryOnBaseProviderResponseMessage, ...DeepARTryOnBaseResponseMessage } as const;
export type DeepARTryOnResponseMessageType = ValueOf<typeof DeepARTryOnResponseMessage>;
//#endregion

// const DeepARTryOnComponentContainer = styled.div`
// 	position: absolute;
// 	top: 0;
// 	left: 0;
// 	width: 100%;
// 	height: 100%;
// 	display: flex;
// 	& .tryon-deepAR-frame {
// 		width: 77%;
// 		height: 100%;
// 		border: none;
// 		outline: none;
// 		margin: auto;
// 	}

// `;

const DeepARMobileContainer = styled.div`
	position: fixed;
	background-color: rgba(0, 0, 0, 0.7);
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	overflow: auto;
	z-index: 12;
	border-radius: 10px;
`;

export const DeepARTryOn: FunctionComponent<TryOnProviderProps> = (props) => {
	console.log('DeepAR props.fineTuningSettings', props.fineTuningSettings);
	const internalState = useInternalState();
	const stateRef = useRef(internalState);
	stateRef.current = internalState;
	const store = stateRef.current.state.environment;
	const [tryOnState, setTryOnState] = useState({} as TryOnProviderExchangeData);
	const { tryon, setTryon } = useZakekeTryOn();
	const [frameWindow, setFrameWindow] = useState(null as Window | null);
	const frameWindowRef = useRef<Window | null>();
	frameWindowRef.current = frameWindow;
	const [deepARIframeUrl, setDeepARIframeUrl] = React.useState<string>('');
	const isDesktop = !(IS_ANDROID || IS_IOS);

	useEffect(() => {
		setTryon({
			...tryon,
			closeFrame: () => tryon?.setVisible?.(false),
			takeScreenshot: () => sendMessage(frameWindowRef.current!, DeepARTryOnResponseMessage.TakeScreenshot, null),
			switchToPDTool: () => {
				console.log('switchToPDTool');
			},
			switchToTryOn: () => {
				console.log('switchToTryOn');
			},
			startPupillaryDistance: (time) => {
				console.log('startPupillaryDistance');
			}
		});
	}, []);

	useEffect(() => {
		switch (tryOnState.type) {
			// TRYON MESSAGES
			case DeepARTryOnReceivedMessage.Start:
				break;
			case DeepARTryOnReceivedMessage.WaitingAuthentication:
				sendMessage(frameWindow!, DeepARTryOnResponseMessage.StartAuthenticationTryOn, {
					token: Zakeke.config.deepARSettings.token
				});
				break;
			case DeepARTryOnReceivedMessage.AuthSuccessful:
				sendMessage(frameWindow!, DeepARTryOnResponseMessage.LoadTryOn, {
					glb: props.obj,
					settings: props.fineTuningSettings
				});
				break;
			case DeepARTryOnReceivedMessage.TryOnLoaded:
				props.onLoaded?.();
				break;
			case DeepARTryOnReceivedMessage.WebcamError:
				props.onWebcamError();
				break;
			case DeepARTryOnReceivedMessage.WebcamStopped:
				props.onClose?.();
				break;
		}
	}, [tryOnState]);

	const sendMessage = (window: Window, message: DeepARTryOnResponseMessageType, value: any) => {
		window.postMessage({ type: message, ...value }, '*');
	};

	const handleMessage = (e: MessageEvent) => {
		setTryOnState(e.data as TryOnProviderExchangeData);
	};

	
		return (
			<DeepARMobileContainer>
				{/* <CloseButton onClick={props.onClose}>X</CloseButton> */}
				<TryOnFrame
					providerTitle='deepAR'
					providerUrl={Zakeke.config.deepARSettings.url}
					onReady={(w) => {
						setFrameWindow(w);
						props.onReady?.();
					}}
					outMessageHandler={handleMessage.bind(this)}
				/>
			</DeepARMobileContainer>
		);
};

// #endregion
